<script setup lang="ts">
import { ProductPage, usePdpRouteHandler } from '@/features/product-page';
import { computed } from 'vue';
import {
  useLoadProductPage,
  useProductPage,
} from '~/features/product-page/business/use-product-page';

const {
  routeSkuId,
  routeProductId: productId,
  routeProductName,
  updateRouteProductTitle,
} = usePdpRouteHandler();

const { error } = await useLoadProductPage(productId.value, routeSkuId.value);
const { state } = useProductPage();

await updateRouteProductTitle(state.product?.title);

// Динамические мета-данные для страницы
useHead({
  title: computed(() => {
    if (state.product?.title) {
      return state.product.title;
    }
    return routeProductName.value ? `${routeProductName.value}` : 'Товар';
  }),
  meta: [
    {
      name: 'description',
      content: computed(() => {
        if (state.product?.shortDescription) {
          return state.product.shortDescription;
        }
        return `Страница товара ${routeProductName.value || ''}`;
      }),
    },
  ],
});
</script>

<template>
  <ClientOnly>
    <ProductPage :product-id="productId" :error="error" />
    <template #fallback>
      <div class="product-page-fallback">
        <div class="container">
          <h1>{{ routeProductName || 'Товар' }}</h1>
          <p>Загрузка информации о товаре...</p>
        </div>
      </div>
    </template>
  </ClientOnly>
</template>

<style scoped>
.product-page-fallback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.product-page-fallback .container {
  text-align: center;
  padding: 40px 20px;
}

.product-page-fallback h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #333;
}

.product-page-fallback p {
  font-size: 1.1rem;
  color: #666;
  margin: 0;
}
</style>
